angular.module('common.directives').directive('healthReports', function () {
  return {
    templateUrl:
      './templates/health-reports/health-reports-list.view.html?t=' +
      webpackHash,
    link: function ($scope, $element) {},
    controller: 'healthReportsListController'
  }
})
